import { Quote } from "../../domain/entity/Quote";

export class QuoteModel extends Quote {
  static fromJson = (json) =>
    new QuoteModel(json?.productId, json?.planName, json?.premium);
}
